// extracted by mini-css-extract-plugin
export default {"wrapper":"tournamentLeaderboard_wrapper__ow9xQ","leaderboard":"tournamentLeaderboard_leaderboard__9qGl7"};